export default "__VITE_ASSET__CimO38F3__"